import Layout from 'components/layout';
import { GTM_VIEW_EXP_JOIN_PAGE } from 'constants/events';
import { useEffect, useRef } from 'react';
import { trackEvent } from 'utils/google-tag-manager';
import { createGetServerSideProps, HandlerType } from 'utils/next/shared-getServerSideProps';
import { TenantTypes, isTenantExpUS } from '@tenants';
import { NOT_FOUND } from 'constants/not-found';
import { FeaturesType } from 'contexts';
import { JoinPageObservabilityService } from 'observability/services/join-page-observability';
import { v4 as uuid } from 'uuid';

import type { GetServerSidePropsContext } from 'next';
import HubspotForm from 'components/hubspot-form';
import FormPage from 'components/form-page';

const HUBSPOT_FORM_PORTAL_ID = '24210079';
const HUBSPOT_FORM_ID = '4580e06f-e40c-4785-b65c-6e143069f3b3';

const handler: HandlerType = async (_context: GetServerSidePropsContext, features?: FeaturesType, tenant?: TenantTypes) => {
  // Only allow access to this page on the eXp US tenant
  if (!isTenantExpUS(tenant.id, features)) {
    return NOT_FOUND;
  }
  return { props: {}};
};

export const getServerSideProps = createGetServerSideProps(handler);

type JoinExpUSContactProps = {
  joinExpFabDestination?: string;
};

export default function JoinExpUSContact({ joinExpFabDestination }: JoinExpUSContactProps) {
  const formSessionIdRef = useRef<string | null>(null);

  useEffect(() => {
    trackEvent(GTM_VIEW_EXP_JOIN_PAGE);
  }, []);

  const handleFormReady = () => {
    formSessionIdRef.current = uuid();
  };

  const handleFormSubmitError = (error: { message?: string }) => {
    if (!formSessionIdRef.current) return;

    try {
      JoinPageObservabilityService.trackFormSubmitFailure({
        error: error.message || 'Form validation failed',
        sessionId: formSessionIdRef.current,
      });
    } catch (err) {
      console.error('[Join Form] Failed to track submit failure:', err);
    }
  };

  return (
    <Layout joinExpFabDestination={joinExpFabDestination}>
      <FormPage
        title="Contact eXp Realty US"
        description="We'd love to hear from you! Fill out the form below and our team will get back to you as soon as possible."
        formContent={
          <HubspotForm 
            portalId={HUBSPOT_FORM_PORTAL_ID} 
            formId={HUBSPOT_FORM_ID} 
            region="na1" 
            targetId="hubspot-form-container"
            onFormReady={handleFormReady}
            onFormSubmitError={handleFormSubmitError}
          />
        }
      />
    </Layout>
  );
}
